/**
 * パララックス
 */

jQuery( function ($) {
  let lastScrollTop = 0;
  let ticking = false;

  function updatePosition( scrollPos ) {
    
    $( '.js-parallax-image img' ).each( function () {
      const pictureElement = $(this).closest('.js-parallax-image');
      const sourceElement = pictureElement.find('source');
      let initialXPosition, initialYPosition, parallaxIntensity;

      if (window.innerWidth >= 1000 && sourceElement.length) {
        initialXPosition = sourceElement.data('position-x');
        initialYPosition = sourceElement.data('position-y');
        parallaxIntensity = sourceElement.data('parallax-intensity');
      } else {
        initialXPosition = $(this).data('position-x');
        initialYPosition = $(this).data('position-y');
        parallaxIntensity = $(this).data('parallax-intensity');
      }
      $(this).css({
        'object-position': `${initialXPosition} calc(${initialYPosition} + ${scrollPos * parallaxIntensity}px)`,
      });

    });
    ticking = false;
  }


  $( document ).on( 'scroll', function () {
      lastScrollTop = $( window ).scrollTop();
      
      if ( ! ticking ) {
          window.requestAnimationFrame( function () {
              updatePosition( lastScrollTop );
          });

          ticking = true;
      }
  });
} );

/**
 * パララックス 画像ブロック
 */
jQuery( function ($) {
    let lastScrollTop = 0;
    let ticking = false;

    function updatePosition(scrollPos) {
        $('.wp-block-image.is-style-parallax img').each(function() {
            const parallaxIntensity = 0.5;
            const scaleFactor = 1.2;
            let offsetTop = $(this).offset().top;
            let height = $(this).height();
            let newHeight = height * scaleFactor;
            let heightDifference = (newHeight - height) / 2;  // 拡大による高さの差を計算

            // 画像が画面内に入る瞬間からtranslateYを適用するための調整
            if(scrollPos + window.innerHeight > offsetTop && scrollPos < offsetTop + height) {
                let percentageScrolledIntoView = (scrollPos + window.innerHeight - offsetTop) / (height + window.innerHeight);
                let translateY = -heightDifference + (2 * heightDifference * percentageScrolledIntoView);
                translateY = Math.max(Math.min(translateY, heightDifference), -heightDifference);  // translateYの範囲を制約
                $(this).css('transform', 'scale(' + scaleFactor + ') translateY(' + translateY + 'px)');
            }
        });

        ticking = false;
    }

    $(document).on('scroll', function() {
        lastScrollTop = $(window).scrollTop();

        if (!ticking) {
            window.requestAnimationFrame(function() {
                updatePosition(lastScrollTop);
            });

            ticking = true;
        }
    });
});


